import { faComment } from '@fortawesome/pro-light-svg-icons';
import { faCheckCircle, faStar } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';
import { Img } from '../../flayr-components';
import SingularOrPluralText from '../../lib/SingularOrPluralText/SingularOrPluralText';

interface IProfileAvatarSectionProps {
  name?: string;
  photo?: string;
  reviewScore?: number;
  reviewCount?: number;
  vaccinationStatus?: string;
  className?: string;
  loading?: boolean;
  contactLink?: string;
}

const ProfileAvatarSection: React.FC<React.PropsWithChildren<IProfileAvatarSectionProps>> = ({
  name,
  photo,
  reviewScore,
  reviewCount,
  vaccinationStatus,
  className,
  loading,
  contactLink,
}) => {
  return (
    <div className={classNames('flex items-center space-x-5', className)}>
      <div className="flex-none w-14 lg:w-20">
        {!!photo && <Img src={photo} size="square" round />}
        {loading && (
          <div className="w-full h-full bg-gray-200 rounded-full animate-pulse" />
        )}
      </div>

      <div className="flex-grow">
        {loading && (
          <div className="grid gap-3">
            <p className="h-5 bg-gray-200 rounded-full animate-pulse"></p>
            <p className="h-5 bg-gray-200 rounded-full animate-pulse"></p>
            <p className="h-3 bg-gray-200 rounded-full animate-pulse"></p>
          </div>
        )}
        <p className="text-xl leading-[1.5em] lg:text-3xl">{name}</p>
        {!!reviewScore && (
          <p className="flex items-center space-x-2">
            <span className="text-lg leading-[1.5em] font-semibold">
              {reviewScore}
            </span>
            <FontAwesomeIcon
              icon={faStar}
              className="text-base text-review-star"
            />

            <span
              hidden={!reviewCount}
              className="px-2 pt-1 text-xs lg:px-0 text-gray-5D"
            >
              ({reviewCount}{' '}
              <SingularOrPluralText number={reviewCount || 0} text="review" />)
            </span>
          </p>
        )}

        {!!vaccinationStatus && (
          <div
            hidden={vaccinationStatus === 'no'}
            className="mt-1 text-xs font-medium uppercase text-success"
          >
            <FontAwesomeIcon icon={faCheckCircle} /> COVID-19{' '}
            {vaccinationStatus === 'yes' && 'Vaccinated'}
            {vaccinationStatus?.includes('exempt') && 'Vaccine Exempt'}
          </div>
        )}
      </div>
      {!!contactLink && (
        <Link
          // to={`/customer-dashboard/inbox/${offer?._id}`}
          to={contactLink || ''}
          className="flex items-center justify-center flex-none w-10 h-10 text-2xl rounded-lg bg-primary bg-opacity-10 text-primary"
        >
          <FontAwesomeIcon icon={faComment} />
        </Link>
      )}
    </div>
  );
};
export default ProfileAvatarSection;
